import React,{useState,useEffect} from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import Paginator from '../../shared/Paginator';
import NoDataFound from '../../shared/NoDataFound';
import { alphaformatDateTime } from "../../utils/dateFormat";
import { makerCheckerActions } from "../../utils/constants";
import TableLoader from '../../shared/TableLoader';
import config from "../../config";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import BrandChecker from "./BrandChecker";

const PendingRequests = ({data,totalPending,currentPage,setCurrentPage,handlePageChange,loader,getPendingRequests,handleTabSwitch,activeRole})=>{
    const [showDrawer,setShowDrawer] = useState(false);
    const [selectedData,setselectedData] = useState();
    const approve = async () => {
        try {
          let res = await api({
            url: selectedData?.route,
            method: "POST",
            responseType: "json",
            data: {
              mc_id:selectedData?.mc_id,
              isapprove: true,
            },
          });
    
          if (res.code === 200) {
            localStorage.removeItem("mc_id");
            handleTabSwitch('request-approved');
            Toast("success", "Approved Successfully");
            setShowDrawer(false);
          } else {
            Toast("error", res?.data?.message);
          }
        } catch (err) {
          console.error(err);
        }
      };
    
    const reject = async (reason) => {
        try {
          let res = await api({
            url: selectedData?.route,
            method: "POST",
            responseType: "json",
            data: {
              mc_id:selectedData?.mc_id,
              isapprove: false,
              rejreason: reason,
            },
          });
    
          if (res.code === 200) {
            localStorage.removeItem("mc_id");
            handleTabSwitch("request-rejected");
            Toast("success", "Rejected Successfully");
            setShowDrawer(false);
          } else {
            Toast("error", res?.data?.message);
          }
        } catch (err) {
          console.error(err);
        }
      };
      
      const isOnlyView =
      localStorage.getItem('mc_role') == '1' ||
      (activeRole == 'maker' && localStorage.getItem('mc_role') == '3');

  return(
    <div>
    <ScrollContainer>
      <table className="table table-bordered">
        <thead>
          <tr className="bg-gray-100">
            <th>Request Sent</th>
            <th>Action type</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
          {(data.length > 0 && !loader) ? (data.map((row, idx) => {
            const created_at = alphaformatDateTime(row.time);

            return (
            <tbody>
              <tr key={idx} className="border-t">
                <td>{row.user_name}</td>
                <td>{makerCheckerActions.find((a) => a.value == row?.action_type)?.label || "-"}</td>
                <td>
                    <div className='font-bold'>{created_at.dateStr}</div>
                    <div className="text-xs text-gray-500 font-bold">{created_at.timeStr}</div>
                  </td>
                <td>
                  <button className="bg-blue-600 text-white px-3 py-1 rounded"
                    onClick={()=>{setselectedData(row);setShowDrawer(true)}}>
                    View
                  </button>
                </td>
              </tr></tbody>
            )
          })) : (!data.length > 0 && !loader ) ? (<NoDataFound colspan="4" />)
        : (<TableLoader colspan="4"/>)}
      </table>
    </ScrollContainer>
    
    {showDrawer && selectedData && (selectedData?.action_type == 1 || selectedData?.action_type == 2) && <BrandChecker data={selectedData} onApprove={approve} onReject={reject} isfromMail={false} onClose={() => setShowDrawer(false)} isOnlyView={isOnlyView} />}
    <div className="flex justify-end">
      {Math.ceil(totalPending / config.PER_PAGE)  > 1 && (
        <Paginator
          pageCount={Math.ceil(totalPending / config.PER_PAGE)}
          handlePageClick={handlePageChange}
          forcePage={currentPage}
        />)
      }
    </div>
    </div>
  )
}
export default PendingRequests;